import { DetailPageAccessMode } from '@app/detailPageLayout.models';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

export const getAccessMode = () => {
  const [mode, setMode] = useState<DetailPageAccessMode>('Create');
  const { id: formId } = useParams();
  const id = useMemo(() => {
    if (formId === undefined) return formId;
    return parseInt(formId, 10);
  }, [formId]);

  useEffect(() => {
    if (id === undefined || id === null) return;
    // TODO check permission
    const hasPermission = true;
    if (hasPermission) setMode('Update');
    else setMode('View');
  }, [id]);

  return { mode, id };
};
